/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://ynnducacrfg4bhkke5chq37ddy.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-cv2t76ckfrbbnlyng5eek4woc4",
    "aws_cognito_identity_pool_id": "ap-south-1:4a1185a4-780a-44e5-a033-fc3ff4daee75",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_F5uNKHWEp",
    "aws_user_pools_web_client_id": "6ctat23ngrsu4tj5kns9as1edb",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "proconnectstagingbucket44112-staging",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
